import { createFileRoute } from '@tanstack/react-router';
import { createServerFn } from '@tanstack/react-start';
import AboutUsPage from '../pages/AboutUsPage';
import { destinationMiddleware } from '../server/middleware/destinationMiddleware';

const loadDestination = createServerFn()
    .middleware([destinationMiddleware])
    .handler(async ({ context }) => {
        return context.destination;
    });

export const Route = createFileRoute('/about-us')({
    beforeLoad: async () => {
        try {
            const destination = await loadDestination();
            return { destination };
        } catch (error) {
            console.error('Failed to load destination:', error);
            throw error;
        }
    },
    loader: async ({ context }) => {
        const { destination } = context;
        return { destination };
    },
    // Server-rendered — see routes/index.jsx for why this replaces Helmet.
    head: ({ loaderData }) => {
        const siteUrl = (loaderData?.destination?.url || 'https://www.maasaimara.com').replace(/\/$/, '');
        const canonicalUrl = `${siteUrl}/about-us`;
        return {
            meta: [
                { title: 'Wilderness Bookings | About Us' },
                {
                    name: 'description',
                    content:
                        'We are Wilderness Bookings Limited, a Kenyan destination marketing company specializing in safari tourism in all major African safari and holiday destinations. We allow our clients to get direct bookings!',
                },
                { property: 'og:title', content: 'Wilderness Bookings | About Us' },
                { property: 'og:url', content: canonicalUrl },
            ],
            links: [
                { rel: 'canonical', href: canonicalUrl },
            ],
        };
    },
    component: AboutUsPage,
    // ── Caching config 
    staleTime: 5 * 60 * 1000,   // reuse cached data for 5 mins on re-navigation
    gcTime: 10 * 60 * 1000,  // keep in memory for 10 mins after route unmounts
});